import e from "react";
import { c as B, t as g } from "./app-a75c1d35.mjs";
import { V as w, a as E } from "./Video-232035c2.mjs";
import { B as m } from "./Block-9b78bd10.mjs";
import { I as N, a as I } from "./Image-d6406817.mjs";
import "./ImageContext-57256dc1.mjs";
import "./Image.module-8b345b58.mjs";
const b = "mouse", v = "mouse__icon", y = "mouse__wheel", T = "wheelUpDown", p = {
  mouse: b,
  mouseIcon: v,
  mouseWheel: y,
  wheelUpDown: T
};
function f() {
  return /* @__PURE__ */ e.createElement("div", { className: p.mouse }, /* @__PURE__ */ e.createElement("div", { className: p.mouseIcon }, /* @__PURE__ */ e.createElement("span", { className: p.mouseWheel })));
}
const C = "hero", S = "hero__block-auto", k = "hero__wrapper", W = "hero__overlay", x = "hero__content", L = "desktop", P = "hero__buttons", H = "hero__title", O = "hero__title--lead-text", A = "hero--align-bottom", R = "hero__scroll-wheel", U = "hero--content-below-image", V = "hero__image-band", M = "hero__image-band-content", $ = "hero__below-image-headline", j = "hero__below-section", q = "hero__below-lead-text", z = "hero__below-buttons", F = "button", o = {
  hero: C,
  heroBlockAuto: S,
  heroWrapper: k,
  heroOverlay: W,
  heroContent: x,
  desktop: L,
  heroButtons: P,
  heroTitle: H,
  heroTitleLeadText: O,
  heroAlignBottom: A,
  heroScrollWheel: R,
  heroContentBelowImage: U,
  heroImageBand: V,
  heroImageBandContent: M,
  heroBelowImageHeadline: $,
  heroBelowSection: j,
  heroBelowLeadText: q,
  heroBelowButtons: z,
  button: F
};
function ee({
  heading: n,
  leadText: t,
  imageAltText: l,
  videoAltText: a,
  buttons: r,
  video: s,
  assetType: c,
  imageData: h,
  viewport: i,
  credits: d,
  variant: u = "default"
}) {
  return u === "contentBelowImage" ? /* @__PURE__ */ e.createElement(
    G,
    {
      heading: n,
      leadText: t,
      imageAltText: l,
      videoAltText: a,
      buttons: r,
      video: s,
      assetType: c,
      imageData: h,
      viewport: i,
      credits: d
    }
  ) : /* @__PURE__ */ e.createElement(
    m,
    {
      topPadding: m.Padding.NONE,
      bottomPadding: m.Padding.NONE,
      "data-testid": "hero-block"
    },
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: o.hero,
        "data-testid": "hero",
        itemScope: !0,
        itemType: "https://schema.org/Thing"
      },
      /* @__PURE__ */ e.createElement(
        _,
        {
          assetType: c,
          imageData: h,
          imageAltText: l,
          video: s,
          videoAltText: a,
          viewport: i,
          credits: d
        }
      ),
      /* @__PURE__ */ e.createElement("div", { className: o.heroOverlay }),
      /* @__PURE__ */ e.createElement(m.Content, { className: o.heroBlockAuto }, /* @__PURE__ */ e.createElement("div", { className: o.heroWrapper }, /* @__PURE__ */ e.createElement("div", { className: o.heroContent }, /* @__PURE__ */ e.createElement(
        "h1",
        {
          className: B(g.heroText, o.heroTitle),
          itemProp: "name"
        },
        n
      ), t && /* @__PURE__ */ e.createElement(
        "p",
        {
          className: B(
            g.textsLeadText,
            o.heroTitle,
            o.heroTitleLeadText
          ),
          itemProp: "description"
        },
        t
      ), /* @__PURE__ */ e.createElement(
        "span",
        {
          className: o.heroButtons,
          "data-testid": "hero-button-container",
          itemProp: "description"
        },
        r
      )))),
      /* @__PURE__ */ e.createElement(m.Content, { className: o.heroAlignBottom }, /* @__PURE__ */ e.createElement("div", { className: o.heroScrollWheel }, /* @__PURE__ */ e.createElement(f, null)))
    )
  );
}
function G({
  heading: n,
  leadText: t,
  imageAltText: l,
  videoAltText: a,
  buttons: r,
  video: s,
  assetType: c,
  imageData: h,
  viewport: i,
  credits: d
}) {
  const u = !!t || !!r?.length;
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: o.heroContentBelowImage,
      "data-testid": "hero-block",
      itemScope: !0,
      itemType: "https://schema.org/Thing"
    },
    /* @__PURE__ */ e.createElement("div", { className: o.heroImageBand, "data-testid": "hero" }, /* @__PURE__ */ e.createElement(
      _,
      {
        assetType: c,
        imageData: h,
        imageAltText: l,
        video: s,
        videoAltText: a,
        viewport: i,
        credits: d
      }
    ), /* @__PURE__ */ e.createElement("div", { className: o.heroOverlay }), /* @__PURE__ */ e.createElement("div", { className: o.heroImageBandContent }, /* @__PURE__ */ e.createElement(
      "h1",
      {
        className: B(
          g.heroText,
          o.heroTitle,
          o.heroBelowImageHeadline
        ),
        itemProp: "name"
      },
      n
    ))),
    u && /* @__PURE__ */ e.createElement("section", { className: o.heroBelowSection }, t && /* @__PURE__ */ e.createElement(
      "p",
      {
        className: o.heroBelowLeadText,
        itemProp: "description"
      },
      t
    ), r && r.length > 0 && /* @__PURE__ */ e.createElement(
      "div",
      {
        className: o.heroBelowButtons,
        "data-testid": "hero-button-container"
      },
      r
    ))
  );
}
function _({
  assetType: n,
  imageData: t,
  imageAltText: l,
  video: a,
  videoAltText: r,
  viewport: s,
  credits: c
}) {
  return n === "image" && t ? /* @__PURE__ */ e.createElement(
    N,
    {
      credits: c,
      src: t.imageSrc,
      width: t.width,
      height: t.height,
      altText: l ?? "",
      imageLoader: t.imageLoader,
      styling: I.HERO
    }
  ) : a && n === "video" ? /* @__PURE__ */ e.createElement(
    w,
    {
      title: r ?? "",
      autoplay: !0,
      videoType: "asset",
      video: a,
      styling: E.HERO,
      viewport: s
    }
  ) : null;
}
export {
  ee as Hero
};
//# sourceMappingURL=Hero.js.map
